import React, { Component } from "react";
import { Form, Row, Col,Input } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  valid,
  errors
} from "../../../../common/Validator";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import DateFns from "date-fns";

import { getProfileInfo} from "../../../../redux/action/profileInfoAction"

import { connect } from "react-redux";

// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateCareerObjective Component for updating the objective details.
 */
 
 var isValid = false
class UpdateCareerObjective extends Component {
  constructor(props) {
    super(props);

    this.state = {
      careerObjective: this.props.data[0]
        ? this.props.data[0].careerObjective
        : "",
      preferredDomain: this.props.data[0]
        ? this.props.data[0].preferredDomain
        : "",
      preferredWorkLoction: this.props.data[0]
        ? this.props.data[0].preferredWorkLoction
        : "",
      currentCtc: this.props.data[0] ? this.props.data[0].currentCtc : "",
      exepeCtc: this.props.data[0] ? this.props.data[0].exepectedCtc : "",
      noticePeriod: this.props.data[0] ? this.props.data[0].noticePeriod : "",
      workingDay: this.props.data[0]
        ? DateFns.format(this.props.data[0].lastWorkingDay ? this.props.data[0]: null, "YYYY-MM-DD")
        : "",
      notes: this.props.data[0] ? this.props.data[0].notes : "",
      id: this.props.data[0] ? this.props.data[0].id : undefined,
      serving: this.props.data[0] ? this.props.data[0].servingNotice : "No",
      todateback: "",
      message: "",
      dateError: "",
      error: "",
      getNoticePeriodData:[],
      errorYear:"",
     
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.dateToChange = this.dateToChange.bind(this);
    this.getNoticePeriod = this.getNoticePeriod.bind(this)
    this.dateCheck = this.dateCheck.bind(this);
   
  }


  // common onchange function 

  onChange(e) {
   Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.value);
  }

 



  // onchange function for date
  dateToChange(e) {
    
    let newdate = new Date(e.target.value);
    console.log(newdate)
    this.setState({
      workingDay: e.target.value,
      todateback: newdate,
      errorYear: "",
    });
}

// date validation(used in onupdate and onsubmit function)
dateCheck(){
  if(this.state.workingDay && this.state.serving ==="Yes"){
    if (
    
      new Date(this.state.workingDay).getFullYear().toString().length < 4 ||
      new Date(this.state.workingDay).getFullYear().toString().length > 4 ||
      new Date (this.state.workingDay).getFullYear() < new Date(Date.now()).getFullYear()
     ) {
     
       this.setState({
         errorYear: "please enter valid date",
      
       });
       isValid=true
     } else {
      
       this.setState({
         errorYear: "",
        
       });
       isValid = false
     }
  }
  else{
    this.setState({
      errorYear: "",
   
    });
    isValid= false
  }
 

}

  // update function by clicking update button

  onUpdate(e) {
  
    e.preventDefault();
    submitValidator(e.target);

    this.dateCheck();

    let data = {
      id: this.state.id,
      canInfoId:this.props.profile.data.id,
      careerObjective: this.state.careerObjective,

      preferredDomain: this.state.preferredDomain,
      preferredWorkLoction: this.state.preferredWorkLoction,
      servingNotice: this.state.serving,
      currentCtc: Number(this.state.currentCtc),
      exepectedCtc: Number(this.state.exepeCtc),
      noticePeriod: this.state.noticePeriod,
      lastWorkingDay: this.state.workingDay,
      notes: this.state.notes,
    };
    if (valid && !isValid) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-expectation`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
          this.setState({
            error:err.response.data.message
          })
            setTimeout(() => {
              this.setState({
                error:""
              })
            }, 2000);
          } 
          else if (err.response && err.response.data.statusCode === 403) {
         this.setState({
          error:err.response.data.message
          })
           setTimeout(() => {
              this.setState({
                error: "",
              });
          this.props.history.push("/signin");
             }, 2000);
          }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }


// submit function by clicking update button
  onSubmit(e) {
    e.preventDefault();
    submitValidator(e.target);
    this.dateCheck();

    let data = {
      canInfoId:this.props.profile.data.id,
      careerObjective: this.state.careerObjective,

      preferredDomain: this.state.preferredDomain,
      preferredWorkLoction: this.state.preferredWorkLoction,

      currentCtc: Number(this.state.currentCtc),
      exepectedCtc: Number(this.state.exepeCtc),
      noticePeriod: this.state.noticePeriod,
      lastWorkingDay: this.state.workingDay,
      notes: this.state.notes,
      servingNotice: this.state.serving,
    };
    console.log(data);

    console.log(data);
    if (valid && !isValid) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-expectation`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }



 

  componentDidMount() {
    this.props.getProfileInfo();
    this.getNoticePeriod()
    refresh();
   this.setState({
      message: "",
      error: "",
    });
  }

  getNoticePeriod() {
    axios
      .get(`${RS_API}/v1/api/notice-period/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getNoticePeriodData: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  render() {
    console.log(errors);
    // destructuring the state
    const {
      preferredDomain,
      preferredWorkLoction,
      careerObjective,
      currentCtc,
      exepeCtc,
      workingDay,
      notes,
      noticePeriod,
      message,
      error,
    } = this.state;

    return (
      <>
       {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.data.length ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Career Objectives</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Career Objective"
                        type="textarea"
                        name="careerObjective"
                        inputClass="form-control-sm"
                        value={careerObjective}
                        change={this.onChange}
                        required={true}
                      />

                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Preferred Work Location"
                        type="textarea"
                        name="preferredWorkLoction"
                        inputClass="form-control-sm"
                        value={preferredWorkLoction}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Expected CTC (INR)"
                        type="number"
                        name="exepeCtc"
                        inputClass="form-control-sm"
                        value={exepeCtc}
                        change={this.onChange}
                        required={true}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                          Serving Notice
                        </span>
                        <select
                          tabIndex="7"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            outline: "none",
                            borderColor: "grey",
                          }}
                          name="serving"
                          value={this.state.serving}
                          id={this.state.serving}
                          required={true}
                          onChange={this.onChange}
                        >
                          <option value="" hidden>
                            Select
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <span style={{ color: "red", fontSize: "12px" }}>
                         {errors.serving ? errors.serving :""}
                        </span>
                      </div>
                      {this.state.serving === "Yes" && (
                        <FormComponent
                          style={{ height: "50px", marginTop: "10px" }}
                          labelClass="bold label-sm"
                          label="Last Working Day"
                          type="date"
                          max={moment().format("YYYY-MM-DD")}
                          name="workingDay"
                          inputClass="form-control-sm"
                          value={workingDay}
                          change={this.dateToChange}
                          required={true}
                        />
                      )}
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                    </Col>
                    <Col>
                      <FormComponent
                        index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Preferred Domain"
                        type="textarea"
                        name="preferredDomain"
                        inputClass="form-control-sm"
                        value={preferredDomain}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Current CTC (INR)"
                        type="number"
                        name="currentCtc"
                        inputClass="form-control-sm"
                        value={currentCtc}
                        change={this.onChange}
                        required={true}
                      />
                       <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                          Notice Period
                        </span>
                        <Input
                          tabIndex="6"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="noticePeriod"
                          className="form-control-sm"
                          value={noticePeriod}
                          onChange={this.onChange}
                          // placeholder="Skill Group"
                          required={true}
                        >
                       
                           <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getNoticePeriodData.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.noticePeriod}
                                  >
                                    {item.noticePeriod}
                                  </option>
                                );
                              })}
                       
                        </Input>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.noticePeriod ? errors.noticePeriod :""}
                        </span>
                      </div>
                    
                      <FormComponent
                        index="8"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Notes"
                        type="textarea"
                        name="notes"
                        inputClass="form-control-sm"
                        value={notes}
                        change={this.onChange}
                     
                        minlength="2"
                        maxlength="60"
                      />
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex="9"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span> Career Objective</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Career Objective"
                        type="textarea"
                        name="careerObjective"
                        inputClass="form-control-sm"
                        value={careerObjective}
                        change={this.onChange}
                        required={true}
                      />

                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Preferred Work Location"
                        type="textarea"
                        name="preferredWorkLoction"
                        inputClass="form-control-sm"
                        value={preferredWorkLoction}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="5"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Expected CTC (INR)"
                        type="number"
                        name="exepeCtc"
                        inputClass="form-control-sm"
                        value={exepeCtc}
                        change={this.onChange}
                        required={true}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                          Serving Notice
                        </span>
                        <select
                          tabIndex="7"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            outline: "none",
                            borderColor: "grey",
                          }}
                          name="serving"
                          value={this.state.serving}
                          id={this.state.serving}
                          required={true}
                          onChange={this.onChange}
                        >
                          <option value="" hidden>
                            Select
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <span style={{ color: "red", fontSize: "12px" }}>
                         {errors.serving ? errors.serving :""}
                        </span>
                      </div>
                      {this.state.serving === "Yes" && (
                        <FormComponent
                          style={{ height: "50px", marginTop: "10px" }}
                          labelClass="bold label-sm"
                          label="Last Working Day"
                          type="date"
                          max={moment().format("YYYY-MM-DD")}
                          name="workingDay"
                          inputClass="form-control-sm"
                          value={workingDay}
                          change={this.dateToChange}
                          required={true}
                        />
                      )}
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                    </Col>
                    <Col>
                   
                      <FormComponent
                        index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Preferred Domain"
                        type="textarea"
                        name="preferredDomain"
                        inputClass="form-control-sm"
                        value={preferredDomain}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />
                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Current CTC (INR)"
                        type="number"
                        name="currentCtc"
                        inputClass="form-control-sm"
                        value={currentCtc}
                        change={this.onChange}
                        required={true}
                      />
                       <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                          Notice Period
                        </span>
                        <Input
                          tabIndex="6"
                          style={{ height: "50px", marginTop: "10px" }}
                          type="select"
                          name="noticePeriod"
                          className="form-control-sm"
                          value={noticePeriod}
                          onChange={this.onChange}
                          // placeholder="Skill Group"
                          required={true}
                        >
                       
                           <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getNoticePeriodData.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.noticePeriod}
                                  >
                                    {item.noticePeriod}
                                  </option>
                                );
                              })}
                       
                        </Input>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.noticePeriod ? errors.noticePeriod :""}
                        </span>
                      </div>
                    

                      <FormComponent
                        index="8"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Notes"
                        type="textarea"
                        name="notes"
                        inputClass="form-control-sm"
                        value={notes}
                        change={this.onChange}
                     
                        minlength="2"
                        maxlength="60"
                      />
                    </Col>
                  </Row>
                  <div className="center">
                    <Button
                     tabIndex="9"
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateCareerObjective)
);
